import CustomError from './customError';

export default class RateLimitError extends CustomError {
  constructor(message: string = 'Rate limit exceeded', nestedError?: Error) {
    super(message, nestedError);
  }
}

export const isRateLimitError = (error: Error): boolean => {
  return error instanceof RateLimitError;
};
